import request from '@/utils/Request'

export type Prefecture = {
  id: number
  name: string
  region_id: number
  stores_count: number
}

export type ListPrefecturesResponse = {
  prefectures: Prefecture[]
}

export async function listPrefectures(regionId: number) {
  return await request.get<ListPrefecturesResponse>(`/regions/${regionId}/prefectures`, {})
}

export async function listAllPrefectures() {
  return await request.get<ListPrefecturesResponse>(`/prefectures`, {})
}